import React from 'react';
import PageSizes from '@/constants/ui/PageSizes';
import translate from '@/lib/intl/translate';
import QueryProvider from '@/modules/QueryProvider';
import CreateLabelForm from './CreateLabelForm';
import LabelList from './LabelList';
import { LabelManagementProvider } from './LabelManagementContext';

const filterParams = {
  labelName: {
    type: String,
    defaultValue: null,
  },
};

function LabelManagementPage() {
  return (
    <QueryProvider
      filterParams={filterParams}
      defaultPageSize={PageSizes[1]}
      isPaginated
    >
      <LabelManagementProvider>
        <div className="max-w-5xl p-4">
          <h2 className="mb-4 type-h2">
            {translate('COMPANY_LABEL_MANAGEMENT')}
          </h2>
          <p className="type-body1">
            {translate('COMPANY_LABEL_MANAGEMENT_DESCRIPTION')}
          </p>
          <CreateLabelForm className="mt-6" />
          <LabelList />
        </div>
      </LabelManagementProvider>
    </QueryProvider>
  );
}

export default LabelManagementPage;
